// extracted by mini-css-extract-plugin
export default {"title":"delete_title__j17ML","buttonPart":"delete_buttonPart__K4wXm","buttonCancel":"delete_buttonCancel__gqJ6Q","buttonDelete":"delete_buttonDelete__hCpLY"};